import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { BrandMark } from '../components/BrandMark';

export default function GoogleAuthPage() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setError('לא התקבל טוקן מגוגל. נסו להתחבר שוב.');
      return;
    }
    let cancelled = false;
    loginWithToken(token)
      .then(() => {
        if (!cancelled) navigate('/', { replace: true });
      })
      .catch(() => {
        if (!cancelled) setError('הכניסה עם Google נכשלה. נסו שוב.');
      });
    return () => {
      cancelled = true;
    };
  }, [loginWithToken, navigate]);

  return (
    <div dir="rtl" className="min-h-full grid place-items-center px-5 bg-paper">
      <div className="w-full max-w-[420px] surface !shadow-deep px-7 py-10 text-center">
        <div className="flex justify-center mb-6">
          <BrandMark size="md" showTagline={false} />
        </div>
        {error ? (
          <>
            <p className="text-red-700 text-[15px] mb-5">{error}</p>
            <Link to="/login" className="text-sage-700 font-semibold hover:underline">
              חזרה להתחברות
            </Link>
          </>
        ) : (
          <>
            <div className="mx-auto h-10 w-10 rounded-2xl border-2 border-sage-300/40 border-t-sage-600 animate-spin mb-4" />
            <p className="text-ink-mute text-[15px]">מתחברים עם Google…</p>
          </>
        )}
      </div>
    </div>
  );
}
